import React from "react";
import PropTypes from "prop-types";
import usePageOffsets from "./usePageOffsets";

/**
 * Khung trang nổi (floating card) — style Geist (Vercel). (Copy từ crm/payment-request/common,
 * dùng chung cho Purchase Requisition + Purchase Order.)
 */
const PageShell = ({ header, children, footer }) => {
  const o = usePageOffsets();
  return (
    <div
      className="geist-scope tw-flex tw-min-h-0 tw-flex-col tw-overflow-hidden tw-bg-geist-bg tw-m-4 tw-rounded-geist-lg tw-shadow-geist-modal tw-border tw-border-solid tw-border-geist-border"
      style={{ position: "fixed", top: o.top, left: o.left, right: o.right, bottom: o.bottom, zIndex: 1 }}
    >
      <div className="tw-flex-shrink-0 tw-bg-geist-bg tw-border-b tw-border-geist-border tw-z-30">{header}</div>
      <div className="tw-flex-1 tw-min-h-0 tw-overflow-auto tw-bg-geist-bg-2">{children}</div>
      {footer && (
        <div className="tw-flex-shrink-0 tw-bg-geist-bg tw-border-t tw-border-solid tw-border-geist-border">{footer}</div>
      )}
    </div>
  );
};
PageShell.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
};

export const SectionHeading = ({ children, className = "" }) => (
  <h3 className={`tw-text-[15px] tw-font-semibold tw-text-geist-fg tw-tracking-tight tw-m-0 ${className}`}>
    {children}
  </h3>
);
SectionHeading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export const FieldLabel = ({ children, className = "", required = false }) => (
  <span className={`tw-inline-block tw-text-[12px] tw-font-medium tw-text-geist-fg-2 tw-mb-1.5 ${className}`}>
    {children}
    {required && <span className="tw-text-geist-error"> *</span>}
  </span>
);
FieldLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  required: PropTypes.bool,
};

export const PageTitle = ({ children, subtitle }) => (
  <div>
    <h1 className="tw-text-[22px] tw-font-semibold tw-tracking-tight tw-text-geist-fg tw-m-0">
      {children}
    </h1>
    {subtitle && <p className="tw-text-[13px] tw-text-geist-fg-3 tw-m-0 tw-mt-0.5">{subtitle}</p>}
  </div>
);
PageTitle.propTypes = {
  children: PropTypes.node,
  subtitle: PropTypes.node,
};

export default PageShell;
